import type { DynamicClient } from '../../types';
import type { DynamicCore } from '../types';

/** @notInstrumented */
export const getCore = (client: DynamicClient): DynamicCore => {
  // @ts-expect-error - this was hidden from the public API
  return client.__core;
};
